import { studies, sites } from '$lib/api';
import { selectedStudy, selectedSite, selectedParticipant } from '$stores/selectionStore';
import { navigate as goto } from 'svelte-routing';
import { effectiveAssignments, hasUnrestrictedAccess } from '$utils/userAssignments.js';

/**
 * Set selected study/site from an assignment row. Returns the landing path
 * the caller should navigate to, or null if the lookup failed.
 */
export async function applyAssignment(assignment) {
  if (!assignment?.protocolNumber) return null;
  const study = await studies.byProtocol(assignment.protocolNumber);
  selectedStudy.set(study);
  selectedParticipant.set(null);

  if (assignment.siteIds?.length > 0) {
    try {
      const siteResponse = await sites.byId({
        siteId: assignment.siteIds[0],
        studyGUID: study._id
      });
      const site = siteResponse?.data || siteResponse;
      selectedSite.set(site || null);
    } catch (_) {
      selectedSite.set(null);
    }
    return '/persons';
  }

  selectedSite.set(null);
  return '/sites';
}

/**
 * Post-login landing: first assignment with sites → /persons; else first
 * study-level assignment → /sites; else admin → /studies.
 */
export async function landAssignedUser(userData) {
  const assignments = effectiveAssignments(userData);
  const firstWithSites = assignments.find((row) => row.siteIds.length > 0);
  const target = firstWithSites || assignments[0];

  if (!target) {
    selectedStudy.set(null);
    selectedSite.set(null);
    selectedParticipant.set(null);
    goto(hasUnrestrictedAccess(userData) ? '/studies' : '/dashboard');
    return;
  }

  try {
    const path = await applyAssignment(target);
    goto(path || (firstWithSites ? '/persons' : '/sites'));
  } catch (_) {
    goto(firstWithSites ? '/persons' : '/sites');
  }
}
